const PolicyViewRootPage = () => (
  <div className="mt-80 h-[calc(100vh-80px-32px)]">
    <iframe src="/policy.html" className="h-full w-full" title="policy" />
  </div>
)

export default PolicyViewRootPage
